import Vue from 'vue'
import Vue2AceEditor from 'vue2-ace-editor'

Vue.component('ace-editor', Vue2AceEditor)
